import React, { useEffect } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Card from "../../../../../../core/Card";
import style from "../../../../../style.module.css";

import { useDispatch } from 'react-redux';
import { updateStaticField } from '../../../../../../store/actions/formBuilderAction';
import { useTranslation } from 'react-i18next';


const EditTermAndConditionModal = ({ data, modalOpen, setModalOpen, language_code, survey_id }) => {

    //State
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation();

    //Yup
    let shape = {
        label: Yup.string().required(t('survey.lRequired')),
    }
    const formSchema = Yup.object().shape(shape)

    //Formik
    let initialValues = {
        label: '',
    }
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: formSchema,
        onSubmit: (formData) => {
            if (formData.label) {
                let options = data.su_options && JSON.parse(data.su_options)
                const payload = {
                    language_code,
                    label: formData.label,
                    name: 'TANDC',
                    options: options ?? { required: false },
                    survey_id
                }
                dispatch(updateStaticField(payload, handleCancel))
            }
        }
    })

    const { values, handleChange, handleBlur, touched, errors, setFieldValue, resetForm, handleSubmit } = formik

    //Functionalities
    const handleCancel = (e) => {
        e?.preventDefault()
        resetForm()
        setModalOpen(false)
    }

    //Effects
    useEffect(() => {
        if (data) {
            setFieldValue('label', data?.su_label_and_options && (JSON.parse(data.su_label_and_options)[language_code] ?? ''))
        }
    }, [data, modalOpen])


    return (
        <>
            <div className={`customvar-modal modal custom-modal fade edit-pop-modal ${modalOpen ? 'show' : ''}`} style={{ display: `${modalOpen ? 'block' : 'none'}` }} id='leadGenTandCFieldEditModal' tabIndex={-1} aria-labelledby="editModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className={`formcontainer ${style.container}`}>
                                    <div className={`formvawrapper modal-edit ${style.wrapper}`}>
                                        <Card view="raised" className={`formstyle p-4 ${style.card}`} >
                                            <div className="edit-field-wrap p-0 mb-4 profile-wrapper">
                                                <h5>{t('survey.builder.edit_t&c')}</h5>
                                                <div className="field-wrap form-wrapper">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="mb-3">
                                                                <label htmlFor="">{t('survey.builder.label')}</label>
                                                                <div className='inputtext position-relative'>
                                                                    <textarea
                                                                        className="form-control"
                                                                        rows="3"
                                                                        placeholder='Sim, desejo receber comunicações de marketing da <a href="https://www.example.com">Vodafone Limited</a>'
                                                                        name='label'
                                                                        value={values.label}
                                                                        onChange={window.modulePermissions.M12.edit == 1 ? handleChange : undefined}
                                                                        onBlur={window.modulePermissions.M12.edit == 1 ? handleBlur : undefined}
                                                                        readOnly={window.modulePermissions.M12.edit != 1}
                                                                    />
                                                                    {touched.label && errors.label && <div className='validation-msg'>{errors.label}</div>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="button-wrap d-flex justify-content-end">
                                                        <button type="button" className="btn btn-bordered" data-bs-dismiss="modal" onClick={(e) => handleCancel(e)}>{t('survey.customFormula.cancel')}</button>
                                                        {window.modulePermissions.M12.edit == 1 && <button type={t('survey.builder.submit')} className="btn btn-primary ms-4">{t('survey.builder.save')}</button>}
                                                    </div>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditTermAndConditionModal